module.exports = "/_next/static/images/energy-eb5358c0bb8af4c8d041dc377cf6ee1b.webp";